// Pure validation logic for AiConfigForm — no React dependency.
// Tests run via: node aiConfigForm.logic.test.mjs

export interface AiConfigFields {
  provider: string;
  model: string;
  base_url: string;
  api_key: string;
  num_predict: number;
  timeout_seconds: number;
  temperature: number;
  max_racks_in_context: number;
  max_equipment_in_context: number;
  max_prompt_chars: number;
}

/** Returns an error message string, or null if valid. */
export function validateAiConfig(cfg: AiConfigFields): string | null {
  if (!cfg.model.trim()) return 'Модель не может быть пустой';
  if (cfg.num_predict < 256 || cfg.num_predict > 8192)
    return 'Макс. токенов: 256–8192';
  if (cfg.timeout_seconds < 30 || cfg.timeout_seconds > 600)
    return 'Таймаут: 30–600 сек';
  if (cfg.temperature < 0 || cfg.temperature > 1)
    return 'Температура: 0.0–1.0';
  if (cfg.max_racks_in_context < 1 || cfg.max_racks_in_context > 20)
    return 'Макс. стоек: 1–20';
  if (cfg.max_equipment_in_context < 1 || cfg.max_equipment_in_context > 50)
    return 'Макс. оборудования: 1–50';
  if (cfg.max_prompt_chars < 1000 || cfg.max_prompt_chars > 10000)
    return 'Макс. символов промпта: 1000–10000';
  if (cfg.provider === 'openai' && !cfg.api_key.trim())
    return 'API Key обязателен для провайдера OpenAI';
  return null;
}

/** Ticket 21: Magic Prompt follows max_autonomy_level; is_enabled is not that seam. */
export function workOrderGeneratePolicyCaption(): string {
  return 'Наряды (Magic Prompt): доступ режет max_autonomy_level, не is_enabled. GET /api/ai/capability-config is_enabled — не этот шов.';
}

export const OLLAMA_DEFAULT_URL = 'http://host.docker.internal:11434';
export const OPENAI_DEFAULT_URL = 'https://api.openai.com/v1';

/** When switching to openai and url is still ollama default, switch to openai default. */
export function defaultBaseUrl(provider: string, currentUrl: string): string {
  if (provider === 'openai' && currentUrl === OLLAMA_DEFAULT_URL)
    return OPENAI_DEFAULT_URL;
  if (provider === 'ollama' && currentUrl === OPENAI_DEFAULT_URL)
    return OLLAMA_DEFAULT_URL;
  return currentUrl;
}
